import { render } from "./AppCard.vue?vue&type=template&id=a9539480&scoped=true"
import script from "./AppCard.vue?vue&type=script&lang=js"
export * from "./AppCard.vue?vue&type=script&lang=js"

import "./AppCard.vue?vue&type=style&index=0&id=a9539480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9539480"]])

export default __exports__